import thunk from 'redux-thunk';
import { useMiddlewareReducer } from './middleware';
var middlewares = [thunk];
export var useAppReducer = function useAppReducer(reducer, initialState) {
  return useMiddlewareReducer(middlewares, reducer, initialState);
};